import { render, staticRenderFns } from "./FeaturePoint.vue?vue&type=template&id=4ef34cfc&scoped=true&"
import script from "./FeaturePoint.vue?vue&type=script&lang=ts&"
export * from "./FeaturePoint.vue?vue&type=script&lang=ts&"
import style0 from "./FeaturePoint.vue?vue&type=style&index=0&id=4ef34cfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef34cfc",
  null
  
)

export default component.exports